import PermissionGuard from "@/permissions/PermissionGuard";
import { PERMISSIONS } from "@/permissions/constant";
import RecordLookupScreen from "./components/RecordLookupScreen";

/**
 * Tenant-side Record Lookup — the answer to a GDPR subject-access request, an
 * EU AI Act explainability request, or an internal investigation.
 *
 * Gated on `record.view` only, and deliberately not a module: a withheld
 * module must never be the reason a tenant cannot answer a regulator.
 */
const RecordLookup = () => (
  <PermissionGuard permission={PERMISSIONS.RECORD_VIEW}>
    <RecordLookupScreen isSuperAdmin={false} basePath="/admin/record-lookup" />
  </PermissionGuard>
);

export default RecordLookup;
